"use client";
import { AppTextField } from "@/common";
import {
  DateTimePicker,
  DateTimePickerProps,
  DateTimePickerToolbarProps,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/vi";
import updateLocale from "dayjs/plugin/updateLocale";
import { forwardRef, memo } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

dayjs.extend(updateLocale);

const customMonthNames = [
  "Tháng 1",
  "Tháng 2",
  "Tháng 3",
  "Tháng 4",
  "Tháng 5",
  "Tháng 6",
  "Tháng 7",
  "Tháng 8",
  "Tháng 9",
  "Tháng 10",
  "Tháng 11",
  "Tháng 12",
];

dayjs.updateLocale("vi", {
  months: customMonthNames,
});

const CustomDateTimePickerToolbar = (
  props: DateTimePickerToolbarProps<Dayjs>
) => {
  return null;
};

const AppDateTimePicker = forwardRef<
  HTMLInputElement,
  DateTimePickerProps<Dayjs> & { size?: "medium" | "small" }
>(
  (
    {
      sx,
      size = "medium",
      ...props
    }: DateTimePickerProps<Dayjs> & {
      size?: "medium" | "small";
    },
    ref
  ) => {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"vi"}>
        <DemoContainer components={["DateTimePicker"]}>
          <DateTimePicker
            inputRef={ref}
            dayOfWeekFormatter={(day) => {
              return dayOfWeekVn[day.day()];
            }}
            slots={{
              textField: AppTextField,
              toolbar: CustomDateTimePickerToolbar,
            }}
            views={["year", "month", "day", "hours", "minutes"]}
            openTo="day"
            sx={{
              "& .MuiPickersCalendarHeader-label": {
                "&::first-letter": {
                  textTransform: "uppercase !important",
                },
              },
              ...sx,
            }}
            {...props}
            slotProps={{
              ...props.slotProps,
              textField: {
                fullWidth: true,
                className: "",
                size: size,
                ...props.slotProps?.textField,
              },
            }}
          />
        </DemoContainer>
      </LocalizationProvider>
    );
  }
);
AppDateTimePicker.displayName = "AppDateTimePicker";
export default memo(AppDateTimePicker);

const dayOfWeekVn = {
  0: "CN", // Chủ Nhật
  1: "T2", // Thứ Hai
  2: "T3", // Thứ Ba
  3: "T4", // Thứ Tư
  4: "T5", // Thứ Năm
  5: "T6", // Thứ Sáu
  6: "T7", // Thứ Bảy
};
